import React, { useEffect, useRef, useState } from "react";
import LayoutBackOffice from "../../../components/LayoutBackOffice";

import { Pagination } from "@mui/material";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver"; // optionnel, mais pratique

import SnackbarAlert from "../../../components/SnackbarAlert";


import { jwtDecode } from "jwt-decode";
import { recupererListeCompletClient, telechargerClientCsv } from "../../../services/visiteurs/CompteClientRequest";

// import { ArrowDownToLine } from "lucide-react";

const CompteClients = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 10,
    nombrePage: 1,
    pagePagination: 1
  });
  const [loadingData, setLoadingData] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [compteClientList, setCompteClientList] = useState([]);

  const [connectedUser, setConnectedUser] = useState(null);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const ClientElts = ({ element }) => {

    return (
      <tr className=" bg-white">
        <td className="px-4 truncate text-sm text-stone-500 font-medium w-60">
          <div className=" truncate">
            {element.nom ? element.nom : "-"}
          </div>
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium w-90">
          <div className=" truncate">
            {element.email ? element.email : "-"}
          </div>
        </td>
      </tr>
    );
  };

  const getlisteDesproduct = () => {
    setLoadingData(true);
    recupererListeCompletClient(pageQuery.page, pageQuery.size,"")
      .then((res) => {
        setLoadingData(false);
        console.log("responses : ",res.data)
        setCompteClientList(res.data.visiteurs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalItems
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error client", error);
      });
  };

  const handleExportCSV = async () => {
    setSearchLoading(true);
    try {
      const response = await telechargerClientCsv();
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;"
      });

      // Méthode manuelle sans librairie
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "compteClient_GodleaderShop.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      // --- OU --- avec file-saver (npm install file-saver)
      // saveAs(blob, 'subscribers.csv');
    } catch (error) {
      console.error("Erreur téléchargement CSV :", error);
    } finally {
      setSearchLoading(false);
    }
  };

  // const handleExportExcel = async () => {
  //   setSearchLoading(true);
  //   try {
  //     const response = await telechargerSubscriberExcel();

  //     // 1) Création du Blob avec le bon MIME-type Excel
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //     });

  //     // 2) Génération d’une URL locale
  //     const url = window.URL.createObjectURL(blob);

  //     // 3) Création et clic sur <a>
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "subscribers.xlsx");
  //     document.body.appendChild(link);
  //     link.click();

  //     // 4) Nettoyage
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //     // // Ou avec file-saver :
  //     // saveAs(blob, 'subscribers.xlsx');
  //   } catch (error) {
  //     console.error("Erreur téléchargement Excel :", error);
  //   } finally {
  //     setSearchLoading(false);
  //   }
  // };

  // === PAGINATION DES ELEMENTS ===
  
  
  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));

    recupererListeCompletClient(value, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setCompteClientList(res.data.visiteurs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalItems
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_admin");
    const decoded = token ? jwtDecode(token) : null;
    setConnectedUser(decoded);
  }, []);

  useEffect(() => {
    setLoadingData(true);
    getlisteDesproduct()
  }, []);

  return (
    <LayoutBackOffice>
      <div className="w-full p-4 ">
        <div className="w-full">
          <h1 className="text-xl md:text-3xl font-extrabold">CompteClients</h1>
          <p className="mt-2 text-gray-500 font-medium text-sm sm:text-base md:text-lg">
            Listes des CompteClients
          </p>
        </div>

        <div className="mt-5 w-full  h-auto justify-end flex xl:flex-row  lg:flex-row md:flex-row flex-col  gap-x-2 overflow-x-scroll sm:overflow-auto gap-y-2">
          {/* {connectedUser && connectedUser.role !== "boutique" && ( */}
          <button
            disabled={isLoading}
            className="bg-primary text-sm text-white h-10 w-full xl:w-fit  lg:w-fit  md:w-fit px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={handleExportCSV}
          >
            Exporter en csv
          </button>
          {/* <button
            disabled={isLoading}
            className="bg-primary text-sm text-white h-10 w-full xl:w-fit  lg:w-fit  md:w-fit px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={handleExportExcel}
          >
            Export en excel
          </button> */}
          {/* )} */}
        </div>

        {/* Liste des CompteClients   */}
        <div className="mt-2 w-full">
          <div className="overflow-x-auto w-full ">
            <table className="custom-table table table-zebra w-full">
              <thead>
                <tr className="bg-black h-12">
                  <th className="text-sm text-white">Nom Complet</th>
                  <th className="text-sm text-white">email</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && compteClientList.length > 0 ? (
                  compteClientList.map((item) => (
                    <ClientElts key={item._id} element={item} />
                  ))
                ) : !loadingData && compteClientList.length === 0 ? (
                  <tr>
                    <td colSpan="2">
                      <div className="w-full h-32 bg-white flex gap-x-2 text-red-500 items-center justify-center">
                        <p className="font-semibold text-lg text-red-600">
                          Aucune compte client trouvée
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && compteClientList.length === 0 ? (
                  <tr>
                    <td colSpan="2">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="30"
                          width="30"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="2">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="30"
                          width="30"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end mt-2">
            <Pagination
              count={pageQuery.nombrePage}
              page={pageQuery.pagePagination}
              variant="outlined"
              shape="rounded"
              onChange={handlePaginationChange}
            />
          </div>
        </div>
      </div>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </LayoutBackOffice>
  );
};

export default CompteClients;
